import request from '@/utils/request'
import type { LoginForm } from '@/types/LoginForm'
import type { LoginResponse } from '@/types/LoginResponse'
import type { RegisterForm } from '@/types/RegisterForm'
import type { RegisterResponse } from '@/types/RegisterResponse'
import type { CaptchaResponse } from '@/types/CaptchaResponse'
import type { ApiResponse } from '@/types/ApiResponse'

export const authApi = {
  // Get captcha image
  getCaptcha(): Promise<CaptchaResponse> {
    return request.get('/api/v1/auth/captcha-image')
  },

  // Login
  login(data: LoginForm): Promise<LoginResponse> {
    return request.post('/admin/api/v1/auth/login', data)
  },

  // Register
  register(data: RegisterForm): Promise<RegisterResponse> {
    return request.post('/admin/api/v1/auth/register', data)
  },

  // Refresh token
  refreshToken(refreshToken: string): Promise<LoginResponse> {
    return request.post('/admin/api/v1/auth/refresh-token', { refreshToken })
  },

  // Logout
  logout(): Promise<ApiResponse> {
    return request.post('/admin/api/v1/auth/logout')
  },
}